import mock from "../../../fake-db/mock.js"
const data = {
    reference: {
        intro: '91% des pharmacies informatisées à Madagascar utilisent PharmaPLUS. Découvrez, ci-dessous, quelques exemples de ceux qui nous font confiance.',
        references: [
            {
                image: '../../../../images/fond/Accueil1.jpg',
                title: 'STIMCO - Antananarivo',
                detail: 'Cras fermentum odio eu feugiat lide par naso tierra. Justo eget nada terra videa magna derita valies darta donna mare fermentum iaculis eu non diam phasellus. Scelerisque felis imperdiet proin fermentum leo. Amet volutpat consequat mauris nunc congue.',
                isImage: false,
                color: 'pink'
            },
            {
                image: '../../../../images/fond/Accueil1.jpg',
                title: 'Sicocean - Antananarivo',
                detail: 'Cras fermentum odio eu feugiat lide par naso tierra. Justo eget nada terra videa magna derita valies darta donna mare fermentum iaculis eu non diam phasellus. Scelerisque felis imperdiet proin fermentum leo. Amet volutpat consequat mauris nunc congue.',
                isImage: false,
                color: 'light-blue'
            },
            {
                image: '../../../../images/fond/Accueil1.jpg',
                title: 'Tranombarotra Fatemi - Antananarivo',
                detail: 'Cras fermentum odio eu feugiat lide par naso tierra. Justo eget nada terra videa magna derita valies darta donna mare fermentum iaculis eu non diam phasellus. Scelerisque felis imperdiet proin fermentum leo. Amet volutpat consequat mauris nunc congue.',
                isImage: false,
                color: 'indigo'
            },
            {
                image: '../../../../images/fond/Accueil1.jpg',
                title: 'Bollywood Spice - Antananarivo',
                detail: 'Cras fermentum odio eu feugiat lide par naso tierra. Justo eget nada terra videa magna derita valies darta donna mare fermentum iaculis eu non diam phasellus. Scelerisque felis imperdiet proin fermentum leo. Amet volutpat consequat mauris nunc congue.',
                isImage: false,
                color: 'purple'
            },
            {
                image: '../../../../images/fond/Accueil1.jpg',
                title: 'K2 Jadida - Tsaralalàna - Antananarivo',
                detail: 'Cras fermentum odio eu feugiat lide par naso tierra. Justo eget nada terra videa magna derita valies darta donna mare fermentum iaculis eu non diam phasellus. Scelerisque felis imperdiet proin fermentum leo. Amet volutpat consequat mauris nunc congue.',
                isImage: false,
                color: 'orange'
            },
            {
                image: '../../../../images/fond/Accueil1.jpg',
                title: 'Librairie Mille Feuilles - Antananarivo',
                detail: 'Cras fermentum odio eu feugiat lide par naso tierra. Justo eget nada terra videa magna derita valies darta donna mare fermentum iaculis eu non diam phasellus. Scelerisque felis imperdiet proin fermentum leo. Amet volutpat consequat mauris nunc congue.',
                isImage: false,
                color: 'green'
            },
            {
                image: '../../../../images/fond/Accueil1.jpg',
                title: 'EconoMarket - Antananarivo ',
                detail: 'Cras fermentum odio eu feugiat lide par naso tierra. Justo eget nada terra videa magna derita valies darta donna mare fermentum iaculis eu non diam phasellus. Scelerisque felis imperdiet proin fermentum leo. Amet volutpat consequat mauris nunc congue.',
                isImage: false,
                color: 'primary'
            },
            {
                image: '../../../../images/fond/Accueil1.jpg',
                title: 'Well Being - Antananarivo',
                detail: 'Cras fermentum odio eu feugiat lide par naso tierra. Justo eget nada terra videa magna derita valies darta donna mare fermentum iaculis eu non diam phasellus. Scelerisque felis imperdiet proin fermentum leo. Amet volutpat consequat mauris nunc congue.',
                isImage: false,
                color: 'secondary'
            },
            {
                image: '../../../../images/fond/Accueil1.jpg',
                title: 'Epione - Antananarivo',
                detail: 'Cras fermentum odio eu feugiat lide par naso tierra. Justo eget nada terra videa magna derita valies darta donna mare fermentum iaculis eu non diam phasellus. Scelerisque felis imperdiet proin fermentum leo. Amet volutpat consequat mauris nunc congue.',
                isImage: false,
                color: 'success'
            },
            {
                image: '../../../../images/fond/Accueil1.jpg',
                title: 'Electroplus - Antsirabe',
                detail: 'Cras fermentum odio eu feugiat lide par naso tierra. Justo eget nada terra videa magna derita valies darta donna mare fermentum iaculis eu non diam phasellus. Scelerisque felis imperdiet proin fermentum leo. Amet volutpat consequat mauris nunc congue.',
                isImage: false,
                color: 'danger'
            },
            {
                image: '../../../../images/fond/Accueil1.jpg',
                title: 'Batiland - Antsirabe',
                detail: 'Cras fermentum odio eu feugiat lide par naso tierra. Justo eget nada terra videa magna derita valies darta donna mare fermentum iaculis eu non diam phasellus. Scelerisque felis imperdiet proin fermentum leo. Amet volutpat consequat mauris nunc congue.',
                isImage: false,
                color: 'warning'
            },
            {
                image: '../../../../images/fond/Accueil1.jpg',
                title: 'Station Jovena Ankaratra - Antsirabe',
                detail: 'Cras fermentum odio eu feugiat lide par naso tierra. Justo eget nada terra videa magna derita valies darta donna mare fermentum iaculis eu non diam phasellus. Scelerisque felis imperdiet proin fermentum leo. Amet volutpat consequat mauris nunc congue.',
                isImage: false,
                color: 'info'
            },
            {
                image: '../../../../images/fond/Accueil1.jpg',
                title: 'Auto-Pièces Poids Lourds - Toamasina',
                detail: 'Cras fermentum odio eu feugiat lide par naso tierra. Justo eget nada terra videa magna derita valies darta donna mare fermentum iaculis eu non diam phasellus. Scelerisque felis imperdiet proin fermentum leo. Amet volutpat consequat mauris nunc congue.',
                isImage: false,
                color: 'indigo'
            },
            {
                image: '../../../../images/fond/Accueil1.jpg',
                title: 'Quincaillerie Mandroso - Toamasina',
                detail: 'Cras fermentum odio eu feugiat lide par naso tierra. Justo eget nada terra videa magna derita valies darta donna mare fermentum iaculis eu non diam phasellus. Scelerisque felis imperdiet proin fermentum leo. Amet volutpat consequat mauris nunc congue.',
                isImage: false,
                color: 'cyan'
            },
            {
                image: '../../../../images/fond/Accueil1.jpg',
                title: 'STIMEX - Toamasina',
                detail: 'Cras fermentum odio eu feugiat lide par naso tierra. Justo eget nada terra videa magna derita valies darta donna mare fermentum iaculis eu non diam phasellus. Scelerisque felis imperdiet proin fermentum leo. Amet volutpat consequat mauris nunc congue.',
                isImage: false,
                color: 'orange'
            },
            {
                image: '../../../../images/fond/Accueil1.jpg',
                title: 'Magasin Chez Michel - Sainte Marie',
                detail: 'Cras fermentum odio eu feugiat lide par naso tierra. Justo eget nada terra videa magna derita valies darta donna mare fermentum iaculis eu non diam phasellus. Scelerisque felis imperdiet proin fermentum leo. Amet volutpat consequat mauris nunc congue.',
                isImage: false,
                color: 'teal'
            },
            {
                image: '../../../../images/fond/Accueil1.jpg',
                title: 'Fidaly - NosyBe',
                detail: 'Cras fermentum odio eu feugiat lide par naso tierra. Justo eget nada terra videa magna derita valies darta donna mare fermentum iaculis eu non diam phasellus. Scelerisque felis imperdiet proin fermentum leo. Amet volutpat consequat mauris nunc congue.',
                isImage: false,
                color: 'green'
            },
            {
                image: '../../../../images/fond/Accueil1.jpg',
                title: 'Super Noor - NosyBe',
                detail: 'Cras fermentum odio eu feugiat lide par naso tierra. Justo eget nada terra videa magna derita valies darta donna mare fermentum iaculis eu non diam phasellus. Scelerisque felis imperdiet proin fermentum leo. Amet volutpat consequat mauris nunc congue.',
                isImage: false,
                color: 'purple'
            },
            {
                image: '../../../../images/fond/Accueil1.jpg',
                title: 'NORO Sarl - Ambanja',
                detail: 'Cras fermentum odio eu feugiat lide par naso tierra. Justo eget nada terra videa magna derita valies darta donna mare fermentum iaculis eu non diam phasellus. Scelerisque felis imperdiet proin fermentum leo. Amet volutpat consequat mauris nunc congue.',
                isImage: false,
                color: 'pink'
            },
            {
                image: '../../../../images/fond/Accueil1.jpg',
                title: 'BAJAJ - Sambava',
                detail: 'Cras fermentum odio eu feugiat lide par naso tierra. Justo eget nada terra videa magna derita valies darta donna mare fermentum iaculis eu non diam phasellus. Scelerisque felis imperdiet proin fermentum leo. Amet volutpat consequat mauris nunc congue.',
                isImage: false,
                color: 'light-blue'
            },
            {
                image: '../../../../images/fond/Accueil1.jpg',
                title: 'Etablissements Firoze Houssen - Sambava',
                detail: 'Cras fermentum odio eu feugiat lide par naso tierra. Justo eget nada terra videa magna derita valies darta donna mare fermentum iaculis eu non diam phasellus. Scelerisque felis imperdiet proin fermentum leo. Amet volutpat consequat mauris nunc congue.',
                isImage: false,
                color: 'indigo'
            },
            {
                image: '../../../../images/fond/Accueil1.jpg',
                title: 'DoubleClick - Mahajanga',
                detail: 'Cras fermentum odio eu feugiat lide par naso tierra. Justo eget nada terra videa magna derita valies darta donna mare fermentum iaculis eu non diam phasellus. Scelerisque felis imperdiet proin fermentum leo. Amet volutpat consequat mauris nunc congue.',
                isImage: false,
                color: 'purple'
            },
            {
                image: '../../../../images/fond/Accueil1.jpg',
                title: 'Haria Store - Mahajanga',
                detail: 'Cras fermentum odio eu feugiat lide par naso tierra. Justo eget nada terra videa magna derita valies darta donna mare fermentum iaculis eu non diam phasellus. Scelerisque felis imperdiet proin fermentum leo. Amet volutpat consequat mauris nunc congue.',
                isImage: false,
                color: 'orange'
            },
            {
                image: '../../../../images/fond/Accueil1.jpg',
                title: 'Etablissements Karimjy - Mahajanga',
                detail: 'Cras fermentum odio eu feugiat lide par naso tierra. Justo eget nada terra videa magna derita valies darta donna mare fermentum iaculis eu non diam phasellus. Scelerisque felis imperdiet proin fermentum leo. Amet volutpat consequat mauris nunc congue.',
                isImage: false,
                color: 'green'
            },
            {
                image: '../../../../images/fond/Accueil1.jpg',
                title: 'Quincaillerie Soa - Mahajanga',
                detail: 'Cras fermentum odio eu feugiat lide par naso tierra. Justo eget nada terra videa magna derita valies darta donna mare fermentum iaculis eu non diam phasellus. Scelerisque felis imperdiet proin fermentum leo. Amet volutpat consequat mauris nunc congue.',
                isImage: false,
                color: 'primary'
            },
            {
                image: '../../../../images/fond/Accueil1.jpg',
                title: 'Ranomandry - Fort Dauphin',
                detail: 'Cras fermentum odio eu feugiat lide par naso tierra. Justo eget nada terra videa magna derita valies darta donna mare fermentum iaculis eu non diam phasellus. Scelerisque felis imperdiet proin fermentum leo. Amet volutpat consequat mauris nunc congue.',
                isImage: false,
                color: 'secondary'
            },
            {
                image: '../../../../images/fond/Accueil1.jpg',
                title: 'Sawaghya - Fort Dauphin',
                detail: 'Cras fermentum odio eu feugiat lide par naso tierra. Justo eget nada terra videa magna derita valies darta donna mare fermentum iaculis eu non diam phasellus. Scelerisque felis imperdiet proin fermentum leo. Amet volutpat consequat mauris nunc congue.',
                isImage: false,
                color: 'success'
            },
        ]
    }
}

mock.onGet("/api/reference/all").reply(() => {
    return [200, data.reference];
});